import React from 'react';
import { usePlan } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/plan/index.tsx';
import { SidebarThemeProvider } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/sidebar-theme/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { Menu } from './menu/index.tsx';
import { useTheme } from './utils.tsx';

export const PlanSidebar = () => {
	const { loading, data } = usePlan();
	const theme = useTheme();

	if (loading) {
		return <Skeleton isFull />;
	}

	if (!data) {
		return null;
	}

	return (
		<>
			{theme ? (
				<SidebarThemeProvider theme={theme}>
					<Menu />
				</SidebarThemeProvider>
			) : (
				<Menu />
			)}
		</>
	);
};

export default PlanSidebar;
